module.exports = __webpack_public_path__ + "img/valores-fazer.04dca70e.svg";